<div class="step-buttons-wrapper" [ngClass]="{ 'justify-content-end': showDone || !showPrevious }">
  <button class="btn btn-primary" (click)="previous.emit()" *ngIf="!showDone && showPrevious">Back</button>
  <button class="btn btn-light" (click)="next.emit()" *ngIf="!showDone">Next</button>
  <button class="btn btn-light" (click)="done.emit()" *ngIf="showDone">Done</button>
</div>
